module.exports = __webpack_public_path__ + "static/media/Emily-Robbins_160px.f2e8f69a.jpg";